import { render } from "./logsView.vue?vue&type=template&id=5076df56&scoped=true"
import script from "./logsView.vue?vue&type=script&lang=js"
export * from "./logsView.vue?vue&type=script&lang=js"

import "./logsView.vue?vue&type=style&index=0&id=5076df56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5076df56"]])

export default __exports__